const env = import.meta.env;

if (globalThis.process === undefined) {
  globalThis.process = { env: {} };
}

for (const key of Object.keys(env)) {
  if (key.startsWith('MIX_')) {
    globalThis.process.env[key] = env[key];
  }
}

if (import.meta.env.MIX_APP_URL) {
  globalThis.process.env.MIX_APP_URL = import.meta.env.MIX_APP_URL;
}
